import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  padding: 16px;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 710px;
  max-height: 710px;
  height: 100%;
  max-width: 50%;
`;

export const TitleWrapper = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const ContentWrapper = styled(Flex)`
  overflow-y: auto;
  overflow-x: hidden;
`;
